import {useEffect, useState} from 'react';
import app from '@src/helpers/app';

export default function useUserId() {
    const [userId, setUserId] = useState(app('auth').getUserId());

    useEffect(() => {
        const auth = app('auth');

        const subscription = auth.onUserDetailsChanged((event, {user}) => {
            setUserId(user?.id ?? null);
        });

        setUserId(auth.getUserId());

        return () => subscription.unsubscribe();
    }, []);

    return userId;
}
